import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { faUserCog } from '@fortawesome/free-solid-svg-icons';
import ReactTable from 'react-table';
import CreateAdmin from './CreateAdmin';
import EditAdmin from './EditAdmin';
import { createAdminUser, editAdminUser, getAdminUsers } from '../../../actions';
import { getColumnWidth } from '../../../helpers/general';
import { USERS_LIST_PAGE_SIZE } from '../../../constants/general';
import TableBaseComponent from '../../common/TableBaseComponent';
import ListPageHeader from '../../common/lists/ListPageHeader';
import Edit from '../../common/forms/buttons/Edit';

class Admins extends TableBaseComponent {
  static propTypes = {
    initialData: PropTypes.array.isRequired,
    pagesQuantity: PropTypes.number.isRequired,
    createAdminUser: PropTypes.func.isRequired,
    editAdminUser: PropTypes.func.isRequired,
    getAdminUsers: PropTypes.func.isRequired
  };
  state = {
    activePage: this.getActivePage(),
    loading: true,
    filteringFieldsList: [],
    data: [],
    columns: [],
    createModalIsOpen: false,
    editModalIsOpen: false,
    editableAdmin: {}
  };

  componentDidMount () {
    this.loadAdminsListData(this.state.activePage);
  }

  loadAdminsListData = activePage => {
    const { getAdminUsers } = this.props;
    this.loadData(activePage, getAdminUsers, USERS_LIST_PAGE_SIZE);
  };

  toggleCreateModal = () => this.setState({ createModalIsOpen: !this.state.createModalIsOpen });
  toggleEditModal = () => this.setState({ editModalIsOpen: !this.state.editModalIsOpen });

  editAdmin = (event, adminData) => {
    event.persist();
    event.preventDefault();
    const { editAdminUser } = this.props;
    const adminId = this.state.editableAdmin.id;
    editAdminUser(adminId, adminData).then(() => {
      event.target.reset();
      this.toggleEditModal();
      this.loadAdminsListData(0);
    });
  };

  setEditableUser = id => {
    this.setState({ editableAdmin: this.props.initialData.find(item => item.id === id) });
    this.toggleEditModal();
  };

  handleChangePassword = (password, temp_password) => {
    const { editAdminUser } = this.props;
    const adminId = this.state.editableAdmin.id;
    this.toggleEditModal();
    return editAdminUser(adminId, { password, temp_password });
  };

  columnRenderer = data => {
    return [
      {
        Header: 'Id',
        accessor: 'id',
        width: 70
      },
      {
        Header: 'First name',
        accessor: 'first_name',
        width: getColumnWidth(data, 'first_name', 'First Name')
      },
      {
        Header: 'Last name',
        accessor: 'last_name',
        width: getColumnWidth(data, 'last_name', 'Last Name')
      },
      {
        Header: 'Email',
        accessor: 'email',
        width: getColumnWidth(data, 'email', 'Email')
      },
      {
        Header: 'Phone',
        accessor: 'phone',
        width: getColumnWidth(data, 'phone', 'Phone')
      },
      {
        Header: 'Edit',
        accessor: 'edit',
        Cell: props => <Edit onClick={() => this.setEditableUser(props.original.id)} />,
        filterable: false,
        sortable: false,
        width: 70
      }
    ];
  };

  render () {
    const { createAdminUser, pagesQuantity } = this.props;
    const { loading, activePage } = this.state;
    const filteredData = this.filterData();
    return (
      <div>
        <ListPageHeader onClick={this.toggleCreateModal} icon={faUserCog} title='Admins' />

        <CreateAdmin
          isOpen={this.state.createModalIsOpen}
          createAdminUser={createAdminUser}
          toggleCreateModal={this.toggleCreateModal}
          getAdminList={this.loadAdminsListData}
        />
        <EditAdmin
          isOpen={this.state.editModalIsOpen}
          handleSubmit={this.editAdmin}
          toggleEditModal={this.toggleEditModal}
          user={this.state.editableAdmin}
          handleChangePassword={this.handleChangePassword}
        />
        <div className='table-list-wrapper'>
          <ReactTable
            data={filteredData}
            loading={loading}
            pages={pagesQuantity}
            page={activePage}
            manual
            filterable
            columns={this.columnRenderer(filteredData)}
            showPageSizeOptions={false}
            onPageChange={this.loadAdminsListData}
            onFilteredChange={this.saveFilter}
            onSortedChange={this.handleSorting}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    initialData: state.admins.adminsList,
    pagesQuantity: state.admins.pagesQuantity
  };
};

const mapDispatchToProps = { createAdminUser, editAdminUser, getAdminUsers };

export default connect(mapStateToProps, mapDispatchToProps)(Admins);



// WEBPACK FOOTER //
// ./src/components/app/admins/index.js